import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable, BehaviorSubject} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {Roles} from '../../pages/settings/roles/roles.model';
import {Permission} from '../../pages/settings/permission/permission.model';
import {RolesRequestParam} from './roles.service';

export interface PermissionRequestParam {
    id: number;
    name: string;

}

@Injectable()
export class PermissionService {

    constructor(private apiRequest: ApiRequestService,
                private appConfig: AppConfig) {
    }

    // fetch Employee
    getPermission(pageNumber: any, noOfRecords: any): Observable<any> {
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', noOfRecords);
        /*params = params.append('s', '1');*/
        return this.apiRequest.get(this.appConfig.permission_url, params);
    }
    // save role permission
    saveRolesAssigned(permission: Permission, id: number): Observable<any> {
        const me = this;

        const bodyData: RolesRequestParam = <RolesRequestParam> {
            'id': permission.id,
            'name': permission.name,

        };

        const permissionDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.post(this.appConfig.role_url + '/' + id + '/assign-permissions', bodyData)
            .subscribe(jsonResp => {
                    let permissionInfoReturn: PermissionRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const fmr: Permission = jsonResp.data[0];

                        permissionInfoReturn = <PermissionRequestParam> {
                            'id': permission.id,
                            'name': permission.name,

                        };

                    } else {
                        console.log('added:----:' + jsonResp.message);
                    }
                    permissionDataSubject.next(permissionInfoReturn);
                },
                err => {
                    console.log('added err:----:' + err);
                });

        return permissionDataSubject;
    }

}
